<template>
	<footer class="mt-3 mb-3 border-top">
		<div class="mt-1 float-left small">Copyright &copy; 2020 <a href="https://www.pointent.com/about/" target="_blank">Point Enterprises, Inc.</a></div>
		<div class="mt-1 float-right small">
			<router-link to="/terms" target="_blank" class="mr-2">General Terms of Service</router-link>&middot;
			<router-link to="/privacy" target="_blank" class="ml-2">Privacy Policy</router-link>
		</div>
	</footer>
</template>
<script>
export default {
  name: 'Footer'
}
</script>
